module.exports = __webpack_public_path__ + "static/p11_gallo-e5bed52f19956250c305bad8541b5d65.png";